import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface ActiveDiscountResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function activeDiscountAction(discountId: string): Promise<ApiResponse<ActiveDiscountResponse>> {
  return api.put<ApiResponse<ActiveDiscountResponse>>(`discounts/${discountId}/activate`)
}
